import React from "react";
import { styled, Container, Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import { Alert, AlertTitle } from "@material-ui/lab";
import WTWLogo from "../wtw-logo.svg";

const AreaContainer = styled("div")({
  margin: "1rem 0",
});

const Header = () => {
  return (
    <AreaContainer>
          <img alt="WTW Logo" src={WTWLogo}></img>
    </AreaContainer>
  );
};

export const NotAuthorized = () => {
  return (
    <Container>
      <Grid container justify="center">
        <Grid item xs={12} sm={8}>
          <Header/>
          <AreaContainer>
            <Alert severity="error">
              <AlertTitle>Fel vid verifiering</AlertTitle>
              Vi kunde inte verifiera dig! Gå tillbaka och försök igen eller kontakta oss!
            </Alert>
          </AreaContainer>
          <AreaContainer>
            <Button variant='contained' color='primary' onClick={() => window.history.back()}>Gå tillbaka ...</Button>
          </AreaContainer>
        </Grid>
      </Grid>
    </Container>
  );
};
